import { render, staticRenderFns } from "./UiFormSelect.vue?vue&type=template&id=c41d2a08&"
import script from "./UiFormSelect.vue?vue&type=script&lang=js&"
export * from "./UiFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports